<div class="scale-anim">
    <span class="scale-anim__dot"></span>
    <span class="scale-anim__dot scale-anim__dot--2"></span>
    <span class="scale-anim__dot scale-anim__dot--3"></span>
</div>
